import { render, staticRenderFns } from "./CommunityPostsCard2.vue?vue&type=template&id=aed7a2ca&"
import script from "./CommunityPostsCard2.vue?vue&type=script&lang=js&"
export * from "./CommunityPostsCard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports